export default "__VITE_ASSET__88401346__"